import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { yiluTracking } from 'utils/index';
import { getURLSearchQuery } from 'utils/paramConverters';

import routes from 'router/routes';

import { constructEurailBacklinkProps } from 'modules/eurail/utils/constructEurailBackLinkProps';

import { getEurailSearchResultsPageQueryParams } from '../../../utils/query-params';
import { EurailSearchFormProps } from '../../SearchInputPage/components/EurailSipSearchForm/types';
import { useEurailSearchResultsProps } from './useEurailSearchResultsProps';

export const useEurailSearchResultsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Parse the query parameters of the page
  const queryParams = useMemo(() => {
    return getEurailSearchResultsPageQueryParams(location);
  }, [location]);

  const { eurailSearchResultsProps } = useEurailSearchResultsProps(queryParams);

  const _props: EurailSearchFormProps = {
    searchInput: { ...queryParams },
    onSubmit(data) {
      navigate({
        pathname: routes.EURAIL_SEARCH_RESULTS,
        search: getURLSearchQuery({
          fareClass: data.fareClass,
          to: data.to,
          adult: data.adult,
          youth: data.youth,
          child: data.child,
          senior: data.senior,
          pass: data.pass,
        }),
      });

      yiluTracking.sendGAEvent({
        event: 'srp_cta_clicked',
        category: 'eurail-srp',
        label: 'eurail_srp_cta_clicked',
      });
    },
  };

  const backLinkProps = constructEurailBacklinkProps(
    t('lounges.srp.backlink.label'),
    routes.EURAIL_SEARCH,
    navigate,
    queryParams,
  );

  return {
    backLinkProps,
    eurailSearchFormProps: _props,
    eurailSearchResultsProps,
  };
};
